/**
 * DateRangePicker Component
 * 시작일과 종료일을 선택할 수 있는 날짜 범위 선택 컴포넌트
 */
import React from "react";
import "./DateRangePicker.css";

interface DateRangePickerProps {
    startDate: string;
    endDate: string;
    onStartDateChange: (value: string) => void;
    onEndDateChange: (value: string) => void;
    startLabel?: string;
    endLabel?: string;
    disabled?: boolean;
    className?: string;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    startLabel = "시작일",
    endLabel = "종료일",
    disabled = false,
    className = "",
}) => {
    const handleStartDateIconClick = () => {
        if (!disabled) {
            const input = document.getElementById("date-range-start") as HTMLInputElement;
            input?.showPicker?.();
        }
    };

    const handleEndDateIconClick = () => {
        if (!disabled) {
            const input = document.getElementById("date-range-end") as HTMLInputElement;
            input?.showPicker?.();
        }
    };

    return (
        <div className={`date-range-picker ${className} ${disabled ? "disabled" : ""}`}>
            <div className="date-range-field">
                <label className="date-range-label">{startLabel}</label>
                <div className="date-input-wrapper">
                    <input
                        type="text"
                        className="date-input"
                        placeholder="YYYY-MM-DD"
                        value={startDate}
                        onChange={(e) => onStartDateChange(e.target.value)}
                        disabled={disabled}
                    />
                    <input
                        type="date"
                        id="date-range-start"
                        className="date-input-hidden"
                        value={startDate}
                        onChange={(e) => onStartDateChange(e.target.value)}
                        disabled={disabled}
                    />
                    <i
                        className="fas fa-calendar calendar-icon"
                        onClick={handleStartDateIconClick}
                        style={{ cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1 }}
                    />
                </div>
            </div>
            <div className="date-range-separator">
                <span>~</span>
            </div>
            <div className="date-range-field">
                <label className="date-range-label">{endLabel}</label>
                <div className="date-input-wrapper">
                    <input
                        type="text"
                        className="date-input"
                        placeholder="YYYY-MM-DD"
                        value={endDate}
                        onChange={(e) => onEndDateChange(e.target.value)}
                        disabled={disabled}
                    />
                    <input
                        type="date"
                        id="date-range-end"
                        className="date-input-hidden"
                        value={endDate}
                        onChange={(e) => onEndDateChange(e.target.value)}
                        disabled={disabled}
                    />
                    <i
                        className="fas fa-calendar calendar-icon"
                        onClick={handleEndDateIconClick}
                        style={{ cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1 }}
                    />
                </div>
            </div>
        </div>
    );
};

export default DateRangePicker;
